<template>
  <div class="search_layout box_wrap">
    <div class="search_box">
      <select-year v-model="param.year"></select-year>
      <select-semester v-model="param.semester"></select-semester>
      <select-course v-model="param.course" :year="param.year" :semester="param.semester"></select-course>

      <div class="search_btn" @click="doSearch">{{ $i18n.translate('검색') }}</div>
    </div>

    <v-row class="mt-3" v-if="isCourseData">
      <v-col>
        <v-container fluid v-for="(item, i) in courseData" :key="i">
          <div class="text-subtitle-2">
            <v-icon>mdi-circle-small</v-icon>
            <span>{{ item.year }} {{ item.semester }}</span>
          </div>
          <div class="c-field-flex-row">
            <v-checkbox v-for="(course, j) in item.courses" :key="j"
                        v-model="param2.courses" :label="course.coursename" :value="course.course_id"
                        dense class="mr-10"
            ></v-checkbox>
          </div>
        </v-container>
      </v-col>
      <v-col cols="1" style="min-width:120px; vertical-align: middle;">
        <div class="search_btn" @click="doSearch2">{{ $i18n.translate('적용') }}</div>
      </v-col>
    </v-row>

    <div class="card box_wrap mt-3" v-if="isTotalData">
      <div class="customChart_label_wrap justify-content-end">
        <div class="label_item" v-for="(data, index) in legendTotals" :key="index">
          <div class="label" :style="data.style"></div>
          <div class="text">{{ data.label }}</div>
        </div>
      </div>
      <div class="card_grid mt-3">
        <card-summary v-for="(item, index) in totalData"
                      is-avg
                      :label="item.studyItem"
                      :total="item.total"
                      :done="item.done"
                      :todo="item.todo"
                      :avg="item.avg"
                      :usercnt="item.usercnt"
                      :key="index">
        </card-summary>
      </div>
    </div>

    <div class="card box_wrap" v-if="isTotalChartData">
      <card-title :title="titles.total.title"></card-title>

      <div class="customChart_label_wrap justify-content-end">
        <div class="label_item" v-for="(data, index) in legendTotals" :key="index">
          <div class="label" :style="data.style"></div>
          <div class="text">{{ data.label }}</div>
        </div>
      </div>

      <v-row>
        <v-col cols="6" v-for="(data, index) in totalChartData" :key="index" >
          <stack-chart :chart-data="data" :height="70">
          </stack-chart>
        </v-col>
      </v-row>
    </div>

    <div class="card" id="partiChart" v-if="isPartiChartData">
      <card-title :title="titles.parti.title"></card-title>

      <div class="customChart_label_wrap justify-content-end">
        <div class="label_item" v-for="(data, index) in ysLegends" :key="index">
          <div class="label" :style="data.style"></div>
          <div class="text">{{ data.label }}</div>
        </div>
      </div>
      <line-chart v-for="(data, index) in partiChartData" :chart-data="data" :key="index" :height=200></line-chart>
    </div>

  </div>

</template>

<script>
import SelectYear from '@/components/input/SelectYear';
import SelectSemester from '@/components/input/SelectSemester';
import SelectCourse from '@/components/input/SelectCourse';
import CardTitle from '@/components/layout/CardTitle.vue';
import CardSummary from '@/components/chart/CardSummary.vue';
import StackChart from '@/components/chart/StackChart';
import LineChart from '@/components/chart/LineChart';
import Mixin from '@/common/mixin';
import UT from "@/common/util";
import { STUDY_ITEMS, SEMESTERS } from "@/common/define";

export default {
  name: "StatusSubject",
  components: {
    SelectYear,
    SelectSemester,
    SelectCourse,
    CardTitle,
    CardSummary,
    StackChart,
    LineChart
  },
  mixins: [Mixin],
  data: () => ({
    param: {
      year: "",
      semester: '',
      course: {}
    },
    param2: {
      courses: []
    },
    courseData: [],
    totalData: [],
    totalChartData: [],
    partiChartData: [],
    legendTotals: [],
    legendPartis: [],
    titles: {
      total: {
        title: '과목별활동현황',
      },
      parti: {
        title: '년도주차별참여율',
      },
    }
  }),
  computed: {
    isSelectedCourse() {
      return !UT.isEmpty(this.param.course.course_id);
    },
    isCourseData() {
      return this.courseData.length > 0;
    },
    isTotalData() {
      return this.totalData.length > 0 && this.isSelectedCourse;
    },
    isTotalChartData() {
      return this.totalChartData.length > 0 && this.isSelectedCourse;
    },
    isPartiChartData() {
      return this.partiChartData.length > 0 && this.isSelectedCourse;
    },
  },
  beforeMount() {
    let now = new Date();
    this.param.year = this.$session.get("year") || `${now.getFullYear()}`;
    this.param.semester = this.$session.get("semester") || '10';
  },
  methods: {
    dataReset(all) {
      if (all) {
        this.courseData = [];
        this.param2.courses = [];
      }
      this.totalData = [];
      this.totalChartData = [];
      this.partiChartData = [];
      this.legendPartis = [];
    },
    doSearch() {
      if (UT.isEmpty(this.param.course.course_id)) {
        UT.alert(this, this.$i18n.translate('교과목을선택하세요'))
        return;
      }
      let req = {
        url: '/api/course/coursecd',
        data: {
          course_id: this.param.course.course_id,
          course_cd: this.param.course.course_cd
        }
      };
      this.dataReset(true);
      UT.api(req).then((res) => {
        if (res.data && res.data.result) {
          let data = res.data.result;
          if (data) {
            let ysMap = {};
            data.forEach((item) => {
              let ys = `${item.year}-${item.semester}`;
              if (!ysMap[ys]) {
                ysMap[ys] = [];
              }
              ysMap[ys].push({
                course_id: item.course_id,
                coursename: item.coursename,
              });
            });
            this.courseData = [];
            Object.entries(ysMap).forEach((item) => {
              let ys = item[0].split('-');
              this.courseData.push({
                year: this.$i18n.translate(`{0}년도`, ys[0]),
                semester: `${SEMESTERS[ys[1]]}`,
                courses: item[1]
              });
            });
          } else {
            UT.alert(this, this.$i18n.translate('과목이없습니다'));
          }
        }
      });
    },
    doSearch2() {
      if (UT.isEmpty(this.param2.courses)) {
        UT.alert(this, this.$i18n.translate('과목을선택하세요'));
        return;
      }
      let req = {
        url: '/api/chart/progress/course/',
        data: {
          course_id_list: this.param2.courses.concat(Number(this.param.course.course_id)),
          user_id: this.$session.get("user_id"),
          type: 'subject'
        }
      };
      this.dataReset(false);
      UT.api(req).then((res) => {
        if (res.data && res.data.result) {
          let data = res.data.result;
          if (data) {
            this.setTotalData(data);
          }
        }
      });
    },
    setTotalData(data) {
      if (data) {
        this.mappingYsLegendColors(data, false);

        this.totalData = [];
        Object.keys(STUDY_ITEMS).forEach((key) => {
          if (data[key] && data[key].total) {
            let ysLabels = Object.keys(data[key]).filter((row) => {
              return row !== 'total' && row !== 'avg';
            }).map((row) => {
              let v = row.split('-');
              return this.$i18n.translate(`{0}년도{1}`, v[0], SEMESTERS[v[1]]);
            });
            let total = {
              studyItem: key,
              ysLabels: ysLabels
            };

            Object.entries(data[key].total).forEach((row) => {
              total[row[0]] = row[1];
            });
            this.totalData.push(total);
          } else {
            this.totalData.push({
              studyItem: key,
              total: 0,
              done: 0,
              avg: 0,
              usercnt: 0
            });
          }
        });
        this.sortData(this.totalData);
        this.setChartData(data);
      }
    },
    setChartData(data) {
      this.totalChartData = [];
      this.partiChartData = [];

      if (data) {
        let lastWeek = 0;
        Object.entries(data).forEach((studyItem) => {
          Object.keys(studyItem[1]).forEach((ys) => {
            if (ys !== 'total' && ys !== 'avg') {
              let ysData = studyItem[1][ys];
              Object.keys(ysData).forEach((w) => {
                if (!isNaN(w)) {
                  lastWeek = Math.max(lastWeek, parseInt(w, 10));
                }
              });
            }
          });
        });

        let weekLabels = [];
        let dataPartis = {};
        let dataTotals = {};
        let dataSummary = {};
        for (let week = 1; week <= lastWeek; week++) {
          let studyItemKeys = Object.keys(data);
          weekLabels.push(this.$i18n.translate(`{0}주차`, week));
          if (week === 1) {
            studyItemKeys.forEach((studyItem) => {
              dataPartis[studyItem] = {};
              dataTotals[studyItem] = {};
              dataSummary[studyItem] = {};

              Object.keys(data[studyItem]).forEach((ys) => {
                if (ys !== 'total' && ys !== 'avg') {
                  dataPartis[studyItem][ys] = [];
                  dataTotals[studyItem][ys] = {
                    done: 0,
                    total: 0,
                  };
                }
              });
            });
          }
          studyItemKeys.forEach((studyItem) => {
            Object.keys(data[studyItem]).forEach((ys) => {
              if (ys === 'total') {
                let myData = data[studyItem][ys];
                dataSummary[studyItem] = {
                  done: myData.done,
                  total: myData.total,
                }
              } else if (ys === 'avg') {
                // skip
              } else {
                let weekData = data[studyItem][ys][week];
                dataPartis[studyItem][ys].push(UT.toFixed(weekData.avg / weekData.total * 100, 2) || 0); // 완료율
                dataTotals[studyItem][ys].done += weekData.avg;
                dataTotals[studyItem][ys].total += weekData.total;
              }
            });
          });
        }
        let chartData = Object.keys(data).map((studyItem) => {
          return {
            studyItem: studyItem,
            totals: dataTotals[studyItem],
            partis: dataPartis[studyItem],
            summary: dataSummary[studyItem],
          }
        });
        chartData.forEach((row) => {
          let datasetTotal = [{
            label: this.$i18n.translate('완료'),
            data: []
          }, {
            label: this.$i18n.translate('미완료'),
            data: []
          }, ];
          let ysLabels = [];
          if (row.totals) {
            Object.entries(row.totals).forEach((p) => {
              if (p[1].total > 0) {
                let v = p[0].split('-');
                ysLabels.push(this.$i18n.translate(`{0}년도{1}`, v[0], SEMESTERS[v[1]]));
                let t = UT.toFixed(p[1].done / p[1].total * 100, 2);
                datasetTotal[0].data.push(t);
                let k = UT.toFixed(100 - t, 2);
                datasetTotal[1].data.push(k);
              }
            });
          }
          if (datasetTotal.length > 0) {
            datasetTotal = datasetTotal.map((row, i) => {
              row.backgroundColor = this.dataColor(i);
              row.barThickness = 15;
              return row;
            });
            this.legendTotals = datasetTotal.map((row) => {
              return {
                label: row.label,
                style: `background-color:${row.backgroundColor}`
              }
            });
            if (ysLabels.length > 0) {
              this.totalChartData.push({
                summary: row.summary,
                title: STUDY_ITEMS[row.studyItem],
                labels: ysLabels,
                unitX: '%',
                datasets: datasetTotal
              });
            }
          }
          //
          let datasetParti = [];
          this.legendPartis = [];
          if (row.partis) {
            Object.entries(row.partis).forEach((p) => {
              let v = p[0].split('-');
              datasetParti.push({
                label: this.$i18n.translate(`{0}년도{1}`, v[0], SEMESTERS[v[1]]),
                backgroundColor: this.ysColors[p[0]],
                borderColor: this.ysColors[p[0]],
                data: p[1]
              });
            });
          }
          datasetParti.push({
            label: this.$i18n.translate('학습자평균'),
            data: row.partiAvgs
          });
          if (datasetParti.length > 0) {
            this.partiChartData.push({
              title: STUDY_ITEMS[row.studyItem],
              unitY: '%',
              maxY: 100,
              labels: weekLabels,
              datasets: datasetParti
            });
          }
        });
        this.sortData(this.totalChartData);
        this.sortData(this.partiChartData);
      }
    },
  }
}
</script>
